import { useCallback, useEffect, useState } from "react";
import { RATES, SUBSCRIPTION } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { Get, Post } from "../../config/api";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonFill } from "react-icons/bs";
import { IoMdRadioButtonOn } from "react-icons/io";
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import { Button, Col, Divider, Row, Spin } from "antd";

const BuySubscription = () => {
  const [rates, setRates] = useState(null);
  const location = useLocation();
  const planId = location?.state?.planId;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const token = useSelector((state) => state.user.userToken);
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const getAllRates = async () => {
    try {
      const response = await Get(RATES.getAllRates, token);
      if (response?.status) {
        setLoading(false);
        setRates(response?.data?.docs);
      }
    } catch (err) {
      setLoading(false);
      console.error(err, "Error fetching rates");
    }
  };

  useEffect(() => {
    if (!location?.state?.planId) {
      navigate(-1);
    }
    getAllRates();
  }, []);
  const fetchSubscriptionAmount = () => {
    if (rates && rates[selectedIndex]) {
      const data = {
        serviceType: rates[selectedIndex]?.serviceType,
        passengerCapacity: rates[selectedIndex]?.passengerCapacity,
        planId,
      };
      Post(SUBSCRIPTION.calculateSubscriptionAmount, data, token)
        .then((response) => {
          if (response?.status) {
            setDetails(response?.data);
          }
        })
        .catch((err) => {
          console.error(err, "Error fetching Subscription Amount");
        });
    }
  };

  useEffect(() => {
    // Trigger fetchSubscriptionAmount whenever selectedIndex changes
    fetchSubscriptionAmount();
  }, [selectedIndex, rates]);


  const CustomCarDetails = ({
    heading,
    subheading,
    number,
    people,
    image,
    text,
    index,
  }) => {
    return (
      <div
        className={`py-4 px-2 justify-between flex items-center w-full ${
          selectedIndex === index ? "bg-[#F6DDB5]" : "bg-white"
        } gap-5`}
        onClick={() => {
          setSelectedIndex(index);
        }}
      >
        <div className="flex justify-center items-center cursor-pointer ">
          {selectedIndex === index ? (
            <IoMdRadioButtonOn size={24} className="text-[#E28C06] mr-4" />
          ) : (
            <RiCheckboxBlankCircleLine
              size={24}
              className="text-customBlack mr-4"
            />
          )}
          {/* <img
              src={ImageUrl(image)}
              alt="car"
              style={{
                maxHeight: "100px",
                maxWidth: "150px",
                objectFit: "cover",
                objectPosition: "center",
              }}
            /> */}

          <div className="flex flex-col items-start justify-center ml-2">
            <h5 className="capitalize font-euclid font-bold text-lg max-sm:text-xs text-customBlack">
              {heading}
            </h5>
            <div className="flex items-center mt-1">
              <div className="flex">
                <BsFillPersonFill size={14} className="text-customLightGray" />
                <p className="font-euclid text-xs max-sm:text-[10px] text-customLightGray font-bold ">
                  {people}
                </p>
              </div>
              {/* <FaShoppingBag
                  size={15}
                  className="text-customLightGray ml-2 mt-[2px]"
                />
                <p className="font-euclid text-xs max-sm:text-[10px] text-customLightGray font-bold mt-[2px]">
                  {people}
                </p> */}
              <p className="capitalize font-euclid font-bold text-xs max-sm:text-[10px] text-customLightGray ml-4">
                {text}
              </p>
            </div>

            {/* <p className="capitalize font-euclid font-bold text-xs max-sm:text-[10px] text-customLightGray">
              {subheading}
            </p> */}
          </div>
        </div>
        {/* <p className="ml-2 font-euclid font-bold text-lg max-sm:text-sm text-customBlack">
          ${number.toFixed(2)}
        </p> */}
        {/* <div className="flex flex-col"> */}
        {/* <p className="capitalize font-euclid font-bold text-[10px] text-customBlack">
              {time}
            </p> */}
        {/* </div> */}
      </div>
    );
  };
  return (
    <Row justify="center py-16" className="bg-white">
      {!loading ? (
        <Col lg={16}>
          <Row>
            <Col md={12} xs={22}>
              <div className="mx-4">
                <h5 className="font-tavi  text-3xl text-black mb-4 max-sm:text-lg ">
                  Pick a Service Type
                </h5>
                <div className="flex flex-col w-full">
                  {Array.isArray(rates) &&
                    rates &&
                    rates.map((rate, index) => (
                      <CustomCarDetails
                        heading={`${rate?.serviceType} Luxury`}
                        // subheading={rate?.description}
                        // number={rate?.price}
                        people={`${rate?.passengerCapacity} Passengers`}
                        image={`demo-${index + 1}.png`}
                        text={`$${rate?.hourlyRate} per hour`}
                        index={index}
                      />
                    ))}
                </div>
              </div>
            </Col>
            <Col md={12} xs={22}>
              <div className="border border-gray-300 py-4 px-4 pay-slip">
                <h4 className="font-tavi text-[20px] text-black mt-2">
                  Pricing Breakdown:
                </h4>
                <div className="flex justify-between mt-4">
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    <span className="text-[#000] font-black text-lg">
                      Membership Title
                    </span>
                  </p>
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    {details?.plan?.title}
                  </p>
                </div>
                <div className="flex justify-between mt-4">
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    <span className="text-[#000] font-black text-lg">Hourly Rate</span>
                  </p>
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    ${details?.hourlyRate}
                  </p>
                </div>
                <div className="flex justify-between mt-4">
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    <span className="text-[#000] font-black text-lg">Total Hours</span>
                  </p>
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    {details?.totalHours}
                  </p>
                </div>
                <div className="flex justify-between mt-4">
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    <span className="text-[#000] font-black text-lg">Actual Rate</span>
                  </p>
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    ${details?.actualRate}
                  </p>
                </div>
                <div className="flex justify-between mt-4">
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    <span className="text-[#000] font-black text-lg">
                      Discounted Rate
                    </span>
                  </p>
                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                    ${details?.actualRate} - {details?.savePercent}% = $
                    {details?.discountedRate}
                  </p>
                </div>
              </div>
              <div style={{ textAlign: "center", margin: "20px 0" }}>
                <Button
                  type="button"
                  className="web-btn xl:px-12 px-3 text-sm max-xl:text-xs mx-4"
                  style={{
                    cursor: "pointer",
                    margin: "2px",
                  }}
                  onClick={() => {
                    navigate("/payment", {
                      state: {
                        type: "Subscription",
                        planId: planId,
                        plan: location?.state?.plan,
                        total: details?.discountedRate,
                        details,
                        serviceType : rates[selectedIndex]?.serviceType,
                        passengerCapacity : rates[selectedIndex]?.passengerCapacity,
                      },
                    });
                  }}
                >
                  continue
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      ) : (
        <Col lg={16}>
          <Spin style={{ margin: "200px 600px" }} />
        </Col>
      )}
    </Row>
  );
};

export default BuySubscription;
